<template>
  <div class="container">
    <div class="d-flex flex-column align-items-center justify-content-center">
        <div class="mt-3">
            <img src="../../assets/images/line/cancelLine.png" alt="">
        </div>
        <h2>กรุณาเลือกเหตุผลในการยกเลิก</h2>
        <p class="m-0">รายการจะถูกยกเลิกทันทีที่คุณยืนยันเหตุผล</p>
        <p class="m-0">ในการส่งยกเลิก (สูงสุด 3 เหตุผล)</p>
        <div class="d-flex row px-5">
            <div v-for="(item, index) in options" :key="index" :class="item.column">
                <b-form-checkbox v-model="item.checked" :value="item.value" :name="item.name" class="d-none">
                    {{ item.label }}
                </b-form-checkbox>
                <b-button size="sm" class="custom-size-button py-1 w-100 mt-2" :variant="item.checked ? 'primary' : 'secondary' " @click="onCheckboxChange(item.value, !item.checked)">
                    {{ item.label }}
                </b-button>
            </div>
            <b-form-textarea
                class="mt-3"
                id="textarea-state"
                v-model="textArea"
                placeholder="บอกเราเพิ่มเติม (ไม่บังคับ)"
                rows="4"
            ></b-form-textarea>
            <b-button size="sm" class="mt-3" block variant="primary" @click="createCancelDraft">ยืนยัน</b-button>
            <!-- <b-button size="sm" class="mt-3" block variant="primary" @click="vConsoleOpen">vConsoletest</b-button> -->
        </div>
    </div>
    
  </div>
</template>

<script>
// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
export default {
    data(){
        return {
            selectedValues: [],
            options: [
                { label: 'เปลี่ยนใจ', value: '1', column: 'col-6', checked: false },
                { label: 'ราคาแพงกว่าที่อื่น', value: '2', column: 'col-6', checked: false },
                { label: 'ลูกค้ายกเลิกรายการ', value: '3', column: 'col-6', checked: false },
                { label: 'สร้างรายการซ้ำ', value: '4', column: 'col-6', checked: false },
                { label: 'ป้อนข้อมูลการจัดส่ง', value: '5', column: 'col-12', checked: false }
            ],
            textArea: ''
        }
    },
    async mounted() {
        await this.$liff.init({ liffId: '1657832585-rRe2YnZY' });
        console.log('login or unlogin: ', this.$liff.isLoggedIn())
        if(this.$liff.isLoggedIn()) {
            const destinationUrl = window.location.href;
            console.log('destinationUrl: ', destinationUrl)
        //     this.$liff.login({ redirectUri: destinationUrl })
        // }else {
            const profile = this.$liff.getProfile().then((profile) => {
                return profile
            })
            const accessTokenLine = this.$liff.getAccessToken()
            const getAId = this.$liff.getAId
            console.log('profile: ', profile)
            console.log('showAccessToken: ', accessTokenLine)
            console.log('getAId: ', getAId)
        }
    },
    methods: {
        vConsoleOpen() {
            // vConsole.show()
        },
        concatLabel() {
            const selectedOptions = this.options.filter(option => option.checked === true);
            return selectedOptions.map(option => option.label).join(',');
        },
        async createCancelDraft() {
            const ref_id = this.$route.query.orderId
            const message = this.concatLabel() +' '+ this.textArea
            try {
                this.$http.post(this.$API_URL + '/line/cancel/feedback', {
                    ref_id: ref_id,
                    type: 'Bill',
                    text: message
                });
            } catch (error) {
                console.log(error);
            }
        },
        assignSelected(value, checked) {
            if(this.selectedValues.includes(value)) {
                let index = this.selectedValues.indexOf(value);
                if (index > -1) {
                    this.selectedValues.splice(index, 1);
                    this.options.find(findId => findId.value === value).checked = checked
                }
            } else {
                if(this.selectedValues.length < 3) {
                    this.selectedValues.push(value)
                    this.options.find(findId => findId.value === value).checked = checked
                }
            }
        },
        onCheckboxChange(value, checked) {
            if(this.selectedValues.length <= 3) {
                this.assignSelected(value, checked)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .custom-size-button {
       border-radius: 30px; 
    }
</style>
